import { Thead as ChakraTableHeader, Th as ChakraTableColumnCell, Tr as ChakraTableRow, Box } from '@chakra-ui/react';
import { useMultiStyleConfig } from '@chakra-ui/system';
import { flexRender } from '@tanstack/react-table';
import React from 'react';

import { useTableExperimentalContext } from './TableExperimentalContext';
import { TableExperimentalColumnDef } from './TableTypes';

import Button from 'atoms/Button/Button';
import Checkbox from 'atoms/Checkbox/Checkbox';
import Icon from 'atoms/Icons/Icon';

const TableHeader = (): React.ReactElement => {
  const tableContext = useTableExperimentalContext();
  const { reactTable, isRowSelectionEnabled, enableSorting } = tableContext;

  const themeStyles = useMultiStyleConfig('TableExperimental', { ...tableContext });

  return (
    <ChakraTableHeader>
      {reactTable.getHeaderGroups().map(headerGroup => (
        <ChakraTableRow key={headerGroup.id}>
          {headerGroup.headers.map((header, index) => {
            const columnDef = header.column.columnDef as TableExperimentalColumnDef<Record<string, unknown>>;
            const isSortable = enableSorting && columnDef.enableSorting !== false;
            return (
              <ChakraTableColumnCell key={header.id} width={columnDef.width}>
                <Box display="flex" height="100%">
                  {isRowSelectionEnabled && index === 0 && (
                    <Checkbox
                      __css={themeStyles.thCheckbox}
                      aria-label="Toogle all rows selection"
                      isChecked={reactTable.getIsAllRowsSelected()}
                      isIndeterminate={reactTable.getIsSomeRowsSelected()}
                      onChange={reactTable.getToggleAllRowsSelectedHandler()}
                    />
                  )}
                  {header.isPlaceholder ? null : (
                    <>
                      {isSortable ? (
                        <Button
                          color="grey.base"
                          justifyContent={columnDef.align === 'right' ? 'end' : 'start'}
                          onClick={header.column.getToggleSortingHandler()}
                          size="xs"
                          sx={themeStyles.thContainer}
                          variant="ghost"
                        >
                          {flexRender(header.column.columnDef.header, header.getContext())}
                          {{
                            asc: <Icon boxSize="12px" marginLeft="4px" type="ArrowUp" />,
                            desc: <Icon boxSize="12px" marginLeft="4px" type="ArrowDown" />
                          }[header.column.getIsSorted() as string] ?? null}
                        </Button>
                      ) : (
                        <Box
                          justifyContent={columnDef.align === 'right' ? 'end' : 'start'}
                          sx={themeStyles.thContainer}
                        >
                          {flexRender(header.column.columnDef.header, header.getContext())}
                        </Box>
                      )}
                    </>
                  )}
                </Box>
              </ChakraTableColumnCell>
            );
          })}
        </ChakraTableRow>
      ))}
    </ChakraTableHeader>
  );
};
export default TableHeader;
